// Dispatch is given as a parameter because we cannot import store due to a problem of circular dependencies
const handleError = (dispatch, error) => {
    console.error(error);
    dispatch('popup/resetPopup', null, { root: true });
    dispatch('popup/setPopup', {
        message: 500 === error.status ? 'Le programme a rencontré un problème. Rechargez la page.' : error.message,
        type: 'error',
    }, { root: true });

    return Promise.reject(error);
};

export default handleError;



// WEBPACK FOOTER //
// ./src/utils/handleError.js